export default __webpack_public_path__ + "static/media/43t.d34c7210.jpg";